import __request__ from "routing/request";
export function list(page = 1, per_page = 15, query, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/profiles", null, { "page": page, "per_page": per_page, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.forwarder/forwarder/profiles", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getByIds(input_profile_ids, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.forwarder/forwarder/profiles/byIds", input_profile_ids, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listAllInputs(page = 1, per_page = 50, query, filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/profiles/inputs", null, { "page": page, "per_page": per_page, "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listInputsOverview(page = 1, per_page = 50, query, filters, sort = "title", order = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/profiles/inputs/overview", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(inputProfileId, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.forwarder/forwarder/profiles/${inputProfileId}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(inputProfileId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.forwarder/forwarder/profiles/${inputProfileId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(inputProfileId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.forwarder/forwarder/profiles/${inputProfileId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listByinputProfileIdAndpageAndper_pageAndquery(inputProfileId, page = 1, per_page = 15, query, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.forwarder/forwarder/profiles/${inputProfileId}/inputs`, null, { "page": page, "per_page": per_page, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createByinputProfileIdAndJSONBody(inputProfileId, JSONBody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.forwarder/forwarder/profiles/${inputProfileId}/inputs`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createSampleInput(inputProfileId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.forwarder/forwarder/profiles/${inputProfileId}/inputs/createSampleInput`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteInput(inputProfileId, forwarderInputId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.forwarder/forwarder/profiles/${inputProfileId}/inputs/${forwarderInputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateByinputProfileIdAndforwarderInputIdAndJSONBody(inputProfileId, forwarderInputId, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.forwarder/forwarder/profiles/${inputProfileId}/inputs/${forwarderInputId}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInput(inputProfileId, forwarderInputId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.forwarder/forwarder/profiles/${inputProfileId}/inputs/${forwarderInputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
